import ControlHorari from "../../model/root/ControlHorari";

const apiUrl = process.env.REACT_APP_API_URL;
export const PostControlHorari = async ( element : ControlHorari , page : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8071/controlhorari`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(element)
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
